// src/components/TotaliOreMensili.js
import React, { useEffect, useState } from 'react';
import { api } from '../utils/api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Papa from 'papaparse';

const TotaliOreMensili = () => {
  const [dati, setDati] = useState([]);
  const [mese, setMese] = useState('');
  const [utenti, setUtenti] = useState([]);
  const [utenteSelezionato, setUtenteSelezionato] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [scaricandoId, setScaricandoId] = useState(null);

  useEffect(() => {
    const oggi = new Date();
    oggi.setMonth(oggi.getMonth() - 1);
    const defaultMese = oggi.toISOString().slice(0, 7);
    setMese(defaultMese);
  }, []);

  useEffect(() => {
    const fetchUtenti = async () => {
      const res = await api.get('/utenti');
      setUtenti(res.data);
    };
    fetchUtenti();
  }, []);

  useEffect(() => {
    const fetchDati = async () => {
      try {
        const res = await api.get('/totali-mensili', {
          params: {
            ...(mese && !startDate && !endDate ? { mese } : {}),
            ...(startDate && endDate ? { startDate, endDate } : {}),
            ...(utenteSelezionato ? { utenteId: utenteSelezionato } : {})
          }
        });
        setDati(res.data);
      } catch (error) {
        alert('Errore nel recupero dei dati.');
      }
    };
    if ((mese || (startDate && endDate))) {
      fetchDati();
    }
  }, [mese, startDate, endDate, utenteSelezionato]);

  const esportaPDF = () => {
    const doc = new jsPDF();
    const titolo = startDate && endDate
      ? `Totali Ore Lavorate dal ${startDate} al ${endDate}`
      : `Totali Ore Lavorate - ${mese}`;
    doc.text(titolo, 14, 14);
    autoTable(doc, {
      startY: 20,
      head: [['Sede', 'Nome', 'Ore Lavorate']],
      body: dati.map(row => [row.sede_nome || '-', row.nome, oreToHHMM(row.ore)]),
    });
    doc.save('totali_ore_mensili.pdf');
  };

  const esportaCSV = () => {
    const csv = Papa.unparse(dati.map(row => ({
      Sede: row.sede_nome || '-',
      Nome: row.nome,
      Ore: row.ore
    })));
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'totali_ore_mensili.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const oreToHHMM = (oreDecimali) => {
    const ore = Math.floor(oreDecimali);
    const minuti = Math.round((oreDecimali - ore) * 60);
    return `${ore}h ${minuti.toString().padStart(2, '0')}m`;
  };

  const scaricaPdfUtente = async (row) => {
    setScaricandoId(row.user_id);
    try {
      const params = {};
      if (mese && !startDate && !endDate) params.mese = mese;
      if (startDate && endDate) {
        params.startDate = startDate;
        params.endDate = endDate;
      }
      const res = await api.get(`/totali-mensili/${row.user_id}/dettaglio`, { params });
      const dettaglio = res.data;
      const doc = new jsPDF();
      const meseLabel = (() => {
        try {
          const dt = new Date(`${dettaglio.mese}-01T00:00:00`);
          return dt.toLocaleDateString('it-IT', { month: 'long', year: 'numeric' });
        } catch {
          return dettaglio.mese;
        }
      })();
      doc.text(`${dettaglio.nome} - ${meseLabel}`, 14, 14);
      autoTable(doc, {
        startY: 28,
        head: [['Data', 'Entrata Matt', 'Uscita Matt', 'Entrata Pom', 'Uscita Pom', 'Ore']],
        body: dettaglio.dettagli.map((d) => [
          new Date(d.data).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit' }),
          d.entrata_matt ? new Date(d.entrata_matt).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '-',
          d.uscita_matt ? new Date(d.uscita_matt).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '-',
          d.entrata_pom ? new Date(d.entrata_pom).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '-',
          d.uscita_pom ? new Date(d.uscita_pom).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' }) : '-',
          oreToHHMM(d.minuti / 60),
        ]),
      });
      const finalY = doc.lastAutoTable.finalY || 28;
      doc.text(`Totale mese: ${oreToHHMM(dettaglio.totale_minuti / 60)}`, 14, finalY + 10);
      doc.save(`presenze_${dettaglio.nome.replace(/\s+/g, '_')}_${dettaglio.mese}.pdf`);
    } catch (error) {
      alert(error.response?.data?.message || 'Errore nel download del PDF');
    } finally {
      setScaricandoId(null);
    }
  };

  return (
    <div>
      <h2>📆 Totali Ore Mensili</h2>

      <div style={{ marginBottom: '10px' }}>
        <label>Mese:</label>
        <input
          type="month"
          value={mese}
          onChange={(e) => {
            setMese(e.target.value);
            setStartDate('');
            setEndDate('');
          }}
          style={{ marginLeft: '10px' }}
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label>Oppure seleziona un intervallo:</label><br />
        <input
          type="date"
          value={startDate}
          onChange={(e) => {
            setStartDate(e.target.value);
            setMese('');
          }}
        />
        <span style={{ margin: '0 10px' }}>→</span>
        <input
          type="date"
          value={endDate}
          onChange={(e) => {
            setEndDate(e.target.value);
            setMese('');
          }}
        />
      </div>

      <div style={{ marginBottom: '10px' }}>
        <label>Utente:</label>
        <select
          value={utenteSelezionato}
          onChange={(e) => setUtenteSelezionato(e.target.value)}
          style={{ marginLeft: '10px' }}
        >
          <option value="">Tutti</option>
          {utenti.map((u) => (
            <option key={u.user_id} value={u.user_id}>
              {u.nome}
            </option>
          ))}
        </select>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <button onClick={esportaPDF}>📄 Esporta PDF</button>
        <button onClick={esportaCSV} style={{ marginLeft: '10px' }}>
          🧾 Esporta CSV
        </button>
      </div>

      <table border="1" cellPadding="6">
        <thead>
          <tr>
            <th style={{ minWidth: '160px' }}>Sede</th>
            <th style={{ minWidth: '200px' }}>Nome</th>
            <th style={{ minWidth: '120px' }}>Ore Lavorate</th>
            <th style={{ minWidth: '120px' }}>PDF</th>
          </tr>
        </thead>
        <tbody>
          {dati.map((r, i) => (
            <tr key={i}>
              <td>{r.sede_nome || '-'}</td>
              <td>{r.nome}</td>
              <td>{oreToHHMM(r.ore)}</td>
              <td>
                <button onClick={() => scaricaPdfUtente(r)} disabled={scaricandoId === r.user_id}>
                  {scaricandoId === r.user_id ? '...' : '📄 PDF'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TotaliOreMensili;
